import Vue from 'vue';
import { LOCAL, ROOT_FLAG } from "@/store/mutations";
import { CONFIG_ENDPOINT } from '@/constants';

const { SET_CONFIG_DATA, COMPLETE_CONFIG } = LOCAL;

export default {
	namespaced: true,
	state: {
		loaded: false,
		data: {},
	},
	getters: {
		array: (state) => (key) => state.data[key].map((data) => data),
		constants: (state) => state.data.config,
	},
	actions: {
		async getAppConfig({ commit, dispatch, state }) {
			await dispatch("loadConfig");
			dispatch("configureApp", state.data, ROOT_FLAG);
			commit(COMPLETE_CONFIG);
		},
		async loadConfig({ commit, dispatch }) {
			let config = window.DATA;

			if (!config) {
				config = await dispatch("loadConfigFromAPI");
			}

			return commit(SET_CONFIG_DATA, config);
		},
		loadConfigFromAPI() {
			return Vue.http.get(CONFIG_ENDPOINT).then(
				(response) => Promise.resolve(response.body),
				(response) => Promise.reject(response.status).then(() => {}, (error) => {
					// eslint-disable-next-line no-console
					console.warn(`API Error: ${error}`);
				})
			);
		},
	},
	mutations: {
		[SET_CONFIG_DATA](state, payload) {
			state.data = payload;
		},
		[COMPLETE_CONFIG](state) {
			state.loaded = true;
		},
	},
};
